import React from "react";
const EmployeeDetails = (attendanceData) => {
  const getMonthYear = (dateString, addmonth = 0) => {
    const date = dateString ? new Date(dateString) : new Date();

    // auto handle month + year overflow
    date.setMonth(date.getMonth() + addmonth);

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const monthYearText = `${
      monthNames[date.getMonth()]
    } ${date.getFullYear()}`;

    return monthYearText;
  };

  return (
    <div>
      <p
        style={{
          fontWeight: "bold",
          fontSize: "1.3rem",
          fontFamily: "sans-serif",
        }}
      >
        Payslip for month of{" "}
        {getMonthYear(attendanceData?.attendanceData?.month)}
      </p>
      <p
        style={{
          fontWeight: "bold",
          fontSize: "1.2rem",
          fontFamily: "sans-serif",
        }}
      >
        Employee Pay Summary
      </p>
      <div>
        <div
          style={{
            display: "flex",
          }}
        >
          <div className="row">
            <div className="col-sm-5">
              <p className="mb-2 text-muted" style={{ fontWeight: 500 }}>
                Employee Name:
              </p>
            </div>
            <div className="col-sm-7">
              {attendanceData?.attendanceData?.employeeData?.firstName}{" "}
              {attendanceData?.attendanceData?.employeeData?.lastName}
            </div>
            <div className="col-sm-5">
              <p className="mb-2 text-muted" style={{ fontWeight: 500 }}>
                Employee Id:
              </p>
            </div>
            <div className="col-sm-7">
              {attendanceData?.attendanceData?.employeeData?.id}
            </div>
            <div className="col-sm-5">
              <p className="mb-2 text-muted" style={{ fontWeight: 500 }}>
                Designation:
              </p>
            </div>
            <div className="col-sm-7">
              {attendanceData?.attendanceData?.employeeData?.roleInOrganisation}
            </div>
            <div className="col-sm-5">
              <p className="mb-2 text-muted" style={{ fontWeight: 500 }}>
                Date of Joining:
              </p>
            </div>
            <div className="col-sm-7">
              {attendanceData?.attendanceData?.employeeData?.dateOfJoining ||
                "-"}
            </div>
            <div className="col-sm-5">
              <p className="mb-2 text-muted" style={{ fontWeight: 500 }}>
                Pay Period:
              </p>
            </div>
            <div className="col-sm-7">
              {getMonthYear(attendanceData?.attendanceData?.month)}
            </div>
            <div className="col-sm-5">
              <p className="mb-2 text-muted" style={{ fontWeight: 500 }}>
                Pay Date:
              </p>
            </div>
            <div className="col-sm-7">
              5 {getMonthYear(attendanceData?.attendanceData?.month, 1)}
            </div>
            <div className="col-sm-5">
              <p className="mb-2 text-muted" style={{ fontWeight: 500 }}>
                Bank Account No:
              </p>
            </div>
            <div className="col-sm-7">
              {attendanceData?.attendanceData?.employeeData
                ?.bankAccountNumber || "-"}
            </div>
            <div className="col-sm-5">
              <p className="mb-2 text-muted" style={{ fontWeight: 500 }}>
                PF Account No:
              </p>
            </div>
            <div className="col-sm-7">
              {attendanceData?.attendanceData?.employeeData?.pfAccountNumber ||
                "-"}
            </div>
          </div>

          <div
            style={{
              margin: "auto",
              textAlign: "center",
              width: "80%",
              border: "1px groove gray",
              padding: "5px",
            }}
          >
            <h2 className="text-muted">Employee Net Pay</h2>
            <h1 style={{ color: "green", fontSize: "2rem" }}>
              ₹{attendanceData?.attendanceData?.paybleSalary.toFixed(2) || 0.0}
            </h1>
            <p className="text-muted">
              Paid Days:{" "}
              {+attendanceData?.attendanceData?.totalFullDaysWithoutSunday +
                +attendanceData?.attendanceData?.totalHalfDaysWithoutSunday +
                +attendanceData?.attendanceData?.totalWorkHolidays +
                +attendanceData?.attendanceData?.totalSundays}{" "}
              | LOP Days: {+attendanceData?.attendanceData?.totalLeavsDays}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDetails;
